import Vue from 'vue'
import {postBlob} from "@/plugins/axios";

export function getBillList(data) {
    return Vue.axios({
        url: '/api/invoices/list',
        method: 'get',
        params: {...data}
    })
}

//我申请的发票
export function getMyBillList(data) {
    return Vue.axios({
        url: '/api/invoices/my_list',
        method: 'get',
        params: {...data}
    })
}

//添加发票
export function addOrEditBill(data) {
    return Vue.axios({
        url: '/api/invoices/store',
        method: 'post',
        data: {...data}
    })
}

export function getBillDetail(id) {
    return Vue.axios({
        url: '/api/invoices/detail',
        method: 'get',
        params: {id}
    })
}

/**
 * 获取开票申请的订单信息
 * @returns {*}
 * @param params
 */
export function getBillApplyOrder(params) {
    return Vue.axios({
        url: '/api/invoices/apply_order',
        method: 'get',
        params: params
    })
}

//审核
export function setBillStatus(data) {
    return Vue.axios({
        url: '/api/invoices/status',
        method: 'post',
        data: {...data}
    })
}

//重置审核
export function resetBillStatus(data) {
    return Vue.axios({
        url: '/api/invoices/resetPass',
        method: 'post',
        data: {...data}
    })
}

// 直接开票
export function directInvoice(data) {
    return Vue.axios({
        url: '/api/invoices/directInvoice',
        method: 'post',
        data: {...data}
    })
}

/**
 * 取消标记开票
 * @param data
 * @returns {*}
 */
export function unDirectInvoice(data) {
    return Vue.axios({
        url: '/api/invoices/unDirectInvoice',
        method: 'post',
        data
    })
}

//发票信息-(销售的)客户开票信息（不计算剩余金额）
export function getSaleCustomerInvoiceInfo(data) {
    return Vue.axios({
        url: '/api/invoices/saleCustomerInvoiceInfo',
        method: 'get',
        params: {...data}
    })
}

// 可直接开票的订单 order_list
export function getDirectOrders(data) {
    return Vue.axios({
        url: '/api/invoices/order_list',
        method: 'post',
        data: {...data}
    })
}

/**
 *
 * 保存审核金额
 * @param data
 * @returns {*}
 */
export function saveInvoiceCheckMoney(data) {
    return Vue.axios({
        url: '/api/invoices/save_check_coney',
        method: 'post',
        data: {...data}
    })
}

/**
 *
 * 保存发票号码
 * @param data
 * @returns {*}
 */
export function saveInvoiceNumber(data) {
    return Vue.axios({
        url: '/api/invoices/save_invoice_number',
        method: 'post',
        data: {...data}
    })
}

//导出-发票记录
export function exportInvoiceList(data) {
    return postBlob('/api/invoices/export', data)
}

/**
 *
 * 保存财务备注
 * @param data
 * @returns {*}
 */
export function saveRemarkFinancial(data) {
    return Vue.axios({
        url: '/api/invoices/save_remark_financial',
        method: 'post',
        data
    })
}

export function markBillDone(data) {
    return Vue.axios({
        url: '/api/invoices/mark_done',
        method: 'post',
        data
    })
}

/**
 * 获取关联的冲账订单
 * @param data
 * @returns {*}
 */
export function getStrikeOrders(data) {
    return Vue.axios({
        url: '/api/invoices/get_strike_orders',
        method: 'post',
        data
    })
}


/**
 * 佣金开票列表
 * @param data
 * @returns {*}
 */
export function getCommissionInvoicesList(data) {
    return Vue.axios({
        url: '/api/commission_invoices/list',
        method: 'get',
        params: {...data}
    })
}


/**
 * 佣金开票-选项
 * @param data
 * @returns {*}
 */
export function getCommissionInvoicesOptions(data) {
    return Vue.axios({
        url: '/api/commission_invoices/options',
        method: 'get',
        params: {...data}
    })
}

export function createCommissionInvoice(data) {
    return Vue.axios({
        url: '/api/commission_invoices/store',
        method: 'post',
        data: {...data}
    })
}

export function updateCommissionInvoiceRecord(id, data) {

    return Vue.axios({
        url: '/api/commission_invoices/update',
        method: 'post',
        data: {...data, id: id}
    })
}

export function getCommissionInvoiceDetail(id) {
    return Vue.axios({
        url: '/api/commission_invoices/detail',
        method: 'get',
        params: {id}
    })
}

export function deleteCommissionInvoiceRecord(id) {
    return Vue.axios({
        url: '/api/commission_invoices/delete',
        method: 'post',
        data: {id}
    })
}

/**
 * 提交审核
 * @param id
 * @returns {*}
 */
export function submitCommissionInvoiceRecord(id) {
    return Vue.axios({
        url: '/api/commission_invoices/submit',
        method: 'post',
        data: {id}
    })
}

/**
 * 申请重审
 * @param id
 * @returns {*}
 */
export function reSubmitCommissionInvoiceRecord(id) {
    return Vue.axios({
        url: '/api/commission_invoices/re_submit',
        method: 'post',
        data: {id}
    })
}
/**
 * 搜索申请人
 * @param keyword
 * @returns {*}
 */
export function searchCommissionApplicant(keyword) {
    return Vue.axios({
        url: '/api/commission_invoices/searchApplicant',
        method: 'post',
        data: {keyword}
    })
}
/**
 * 佣金开票-搜索客户
 * @param keyword
 * @returns {*}
 */
export function searchCommissionInvoiceCustomer(keyword) {
    return Vue.axios({
        url: '/api/commission_invoices/searchCustomer',
        method: 'post',
        data: {keyword}
    })
}

/**
 * 佣金开票-搜索发票抬头
 * @param keyword
 * @returns {*}
 */
export function searchCommissionInvoiceTitle(keyword) {
    return Vue.axios({
        url: '/api/commission_invoices/searchInvoiceTitle',
        method: 'post',
        data: {keyword}
    })
}

/**
 * 佣金开票-搜索红人
 * @param keyword
 * @returns {*}
 */
export function searchCommissionArtist(keyword) {
    return Vue.axios({
        url: '/api/commission_invoices/searchArtist',
        method: 'post',
        data: {keyword}
    })
}